/**
 * Resolves the dependencies of a service.
 * @param deps - The dependencies to resolve.
 * @param container - The container to resolve the dependencies from.
 * @param caller - The caller of the service.
 * @returns The resolved dependencies.
 */
export function resolveDeps(deps, container, caller) {
    const resolved = {};
    for (const [key, value] of Object.entries(deps)) {
        resolved[key] = value.resolve(container, caller);
    }
    return resolved;
}
//# sourceMappingURL=resolveDeps.js.map